export const RAG_BASE_URL = (import.meta.env.VITE_RAG_API_URL ?? 'http://localhost:8080').replace(
  /\/+$/,
  '',
);
